import { ref, computed } from 'vue'
import { useGlobalConfig } from 'vuestic-ui'

export const THEME_NAMES = {
  LIGHT: 'LIGHT',
  ORIGINAL: 'ORIGINAL',
  DARK: 'DARK',
  SEMI_DARK: 'SEMI_DARK',
}

export const COLOR_THEMES = [
  {
    name: THEME_NAMES.LIGHT,
    colors: {
      primary: '#000',
      secondary: '#666E75',
      success: '#3D9209',
      info: '#158DE3',
      danger: '#E42222',
      warning: '#FFD43A',
      backgroundPrimary: '#FFFFFF',
      backgroundSecondary: '#FFFFFF',
      backgroundElement: '#ECF0F1',
      backgroundBorder: '#DEE5F2',
      textPrimary: '#262824',
      textInverted: '#FFFFFF',
      shadow: 'rgba(0, 0, 0, 0.12)',
      focus: '#49A8FF',
      transparent: 'rgba(0, 0, 0, 0)',
      backgroundLanding: '#f4f9fc',
      backgroundLandingBorder: 'rgba(155, 179, 206, 0.8)',
    },
  },
  {
    name: THEME_NAMES.DARK,
    colors: {
      primary: '#6F92DA',
      secondary: '#A8AEBA',
      success: '#3d9209',
      info: '#2c82e0',
      danger: '#e42222',
      warning: '#ffd43a',
    },
  },
  {
    name: THEME_NAMES.SEMI_DARK,
    colors: {
      primary: '#6F92DA',
      secondary: '#A8AEBA',
      success: '#3d9209',
      info: '#2c82e0',
      danger: '#e42222',
      warning: '#ffd43a',
    },
  },
  {
    name: THEME_NAMES.ORIGINAL,
    colors: {
      primary: '#6EDC7D',
      secondary: '#A8AEBA',
      success: '#76E18D',
      info: '#2c82e0',
      danger: '#e34b4a',
      warning: '#ffc200',
    },
  },
]

export function useTheme() {
  const themeNameRef = ref(THEME_NAMES.LIGHT)
  const { mergeGlobalConfig } = useGlobalConfig()

  const setTheme = (themeName: keyof typeof THEME_NAMES) => {
    themeNameRef.value = themeName
    const theme = COLOR_THEMES.find((theme) => theme.name === themeName)

    if (!theme) {
      throw new Error('Theme not found')
    }

    mergeGlobalConfig({
      colors: { variables: theme.colors },
    })
  }

  const theme = computed(() => COLOR_THEMES.find((theme) => theme.name === themeNameRef.value))
  return { setTheme, themeName: themeNameRef, theme }
}
